import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ellenAndEden from "../assets/computerbackground.jpg";

import { CheckerDivider } from "../components";

const codeBehindApps = "/assets/codebehindapps.svg";
const airegulation = "/assets/aireg.svg";
const agenticep = "/assets/agenticep.svg";

const SPOTIFY_SHOW_URI = "spotify:show:6eDM2coAkTGam11bhZts0G";
const SPOTIFY_SHOW_EMBED =
  "https://open.spotify.com/embed/show/6eDM2coAkTGam11bhZts0G?utm_source=generator";

type SpotifyController = {
  play: () => void;
  loadUri: (uri: string) => void;
  destroy?: () => void;
};
type SpotifyIframeApi = {
  createController: (
    el: HTMLElement,
    options: { uri: string; width: string | number; height: string | number },
    cb: (controller: SpotifyController) => void,
  ) => void;
};

declare global {
  interface Window {
    spotifyApiReady?: Promise<SpotifyIframeApi>;
  }
}

const PLATFORMS: {
  name: string;
  href: string;
  Icon: () => JSX.Element;
}[] = [
  {
    name: "Spotify",
    href: "https://open.spotify.com/show/6eDM2coAkTGam11bhZts0G",
    Icon: SpotifyIcon,
  },
  {
    name: "Apple Podcasts",
    href: "https://podcasts.apple.com/us/podcast/thats-girl-code/id1826327958",
    Icon: ApplePodcastsIcon,
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@thatsgirlcodepod",
    Icon: YouTubeIcon,
  },
];

function SpotifyIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141 4.26-1.26 9.78-.6 13.5 1.68.361.181.54.78.241 1.141zm.12-3.36C15.24 8.4 8.76 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.56.3z" />
    </svg>
  );
}

function ApplePodcastsIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 0C5.373 0 0 5.373 0 12c0 4.127 2.084 7.766 5.259 9.917l.087-3.05A9.6 9.6 0 0 1 2.4 12C2.4 6.698 6.698 2.4 12 2.4c5.302 0 9.6 4.298 9.6 9.6a9.6 9.6 0 0 1-2.946 6.917l.087 3.05C21.916 19.766 24 16.127 24 12c0-6.627-5.373-12-12-12zm0 4.8a7.2 7.2 0 0 0-4.46 12.85l.08-2.793A4.8 4.8 0 1 1 16.38 14.86l.08 2.79A7.2 7.2 0 0 0 12 4.8zm0 4.8a2.4 2.4 0 0 0-1.49 4.28L10.08 24h3.84l-.43-10.12A2.4 2.4 0 0 0 12 9.6z" />
    </svg>
  );
}

function YouTubeIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

const EPISODES = [
  {
    id: 1,
    title: "The Code Behind Your Favorite Apps",
    description:
      "Eden & Ellen break down the tech behind four of your favorite apps—TikTok, Pinterest, Uber, and Netflix. We’re talking real-time data, machine learning, microservices, and the backend magic that makes these platforms work.",
    thumbnail: codeBehindApps,
    spotifyId: "6cQl6q6zPjFtSqslaiFaBn",
  },
  {
    id: 2,
    title: "The Price of Winning the AI Race",
    description:
      "Deep but digestible two-part conversation on AI, social media, and the incentives shaping the future. We unpack how tech moved from monetizing attention to monetizing intimacy - and what that means for mental health, misinformation, privacy, and who’s actually accountable when things go sideways.",
    thumbnail: airegulation,
    spotifyId: "693C2R7syNVRaCX7qJEfNi",
  },
  {
    id: 3,
    title: "Agentic Systems: Details for the Developers",
    description:
      "In this episode of That’s Girl Code, we explore agentic AI systems that go beyond traditional generative models to perceive their environment, reason about goals, take action, and learn over time.",
    thumbnail: agenticep,
    spotifyId: "0rAL31TuOLiXqUbY9vPCAV",
  },
];

export function Podcast() {
  const { hash, state } = useLocation();
  const autoplay = (state as { autoplay?: boolean } | null)?.autoplay === true;
  const [episodeUri, setEpisodeUri] = useState<string | null>(null);
  const playerUri = episodeUri ?? (autoplay ? SPOTIFY_SHOW_URI : null);

  const playEpisode = (spotifyId: string) => {
    setEpisodeUri(`spotify:episode:${spotifyId}`);
    document
      .getElementById("latest-player")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);

  const embedRef = useRef<HTMLDivElement>(null);
  const controllerRef = useRef<SpotifyController | null>(null);
  const pendingUriRef = useRef<string | null>(null);

  useEffect(() => {
    if (!playerUri) return;

    if (controllerRef.current) {
      controllerRef.current.loadUri(playerUri);
      controllerRef.current.play();
      return;
    }

    pendingUriRef.current = playerUri;
    let cancelled = false;
    window.spotifyApiReady?.then((api) => {
      if (cancelled || !embedRef.current || controllerRef.current) return;
      api.createController(
        embedRef.current,
        { uri: playerUri, width: "100%", height: 232 },
        (c) => {
          controllerRef.current = c;
          const latest = pendingUriRef.current;
          if (latest && latest !== playerUri) c.loadUri(latest);
          c.play();
        },
      );
    });
    return () => {
      cancelled = true;
    };
  }, [playerUri]);

  useEffect(
    () => () => {
      controllerRef.current?.destroy?.();
      controllerRef.current = null;
    },
    [],
  );

  return (
    <div className="min-h-screen bg-cream">
      <Nav />

      {/* ── Hero ── */}
      <section className="relative overflow-hidden h-[40vh] min-h-[280px] md:h-[48vh]">
        <img
          src={ellenAndEden}
          alt="Ellen and Eden"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center 15%",
          }}
        />
        {/* gradient overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to bottom, rgba(13,5,7,0.15) 0%, rgba(13,5,7,0.78) 100%)",
          }}
        />
        {/* title copy */}
        <div className="absolute inset-0 flex flex-col justify-end px-6 sm:px-[6%] pb-4 sm:pb-[2%]">
          <h1
            className="font-playfair font-bold text-cream text-[28px] sm:text-[50px] md:text-[70px] leading-[1.05] mb-2 animate-fade-up whitespace-nowrap"
            style={{ animationDelay: "100ms" }}
          >
            THAT'S{" "}
            <span
              className="font-script italic text-tgc-pink-soft"
              style={{ fontSize: "2.60em" }}
            >
              girl{" "}
            </span>
            CODE
          </h1>
        </div>
      </section>

      {/* ── Listen & Watch ── */}
      <section className="bg-cream px-6 py-12 sm:px-[8%] sm:pt-14 sm:pb-16">
        {/* heading */}
        <h2
          className="font-montserrat text-center"
          style={{
            fontSize: "clamp(18px, 2.2vw, 26px)",
            fontWeight: 700,
            letterSpacing: "0.16em",
            color: "#1a0a0b",
            margin: "0 0 22px",
          }}
        >
          LISTEN &amp; WATCH
        </h2>

        {/* platform icons */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-[14px] mb-10">
          {PLATFORMS.map(({ name, href, Icon }) => (
            <a
              key={name}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              title={name}
              aria-label={name}
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                background: "#571310",
                color: "#fffcef",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "opacity 0.2s ease, transform 0.2s ease",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.opacity = "0.85";
                (e.currentTarget as HTMLElement).style.transform =
                  "translateY(-2px) scale(1.08)";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.opacity = "1";
                (e.currentTarget as HTMLElement).style.transform =
                  "translateY(0) scale(1)";
              }}
            >
              <Icon />
            </a>
          ))}
        </div>

        {/* spotify embed — Terminal "▶ run · latest episode" deep-links to this with autoplay */}
        <div
          id="latest-player"
          className="mx-auto"
          style={{
            maxWidth: "520px",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 2px 16px rgba(87,19,16,0.12)",
            scrollMarginTop: "80px",
          }}
        >
          {playerUri ? (
            <div ref={embedRef} style={{ minHeight: 232 }} />
          ) : (
            <iframe
              title="That's Girl Code — latest episode"
              src={SPOTIFY_SHOW_EMBED}
              width="100%"
              height="232"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              style={{ display: "block", border: 0 }}
            />
          )}
        </div>
      </section>
      <CheckerDivider />

      {/* ── Recent Episodes ── */}
      <section
        id="episodes"
        className="bg-darkred px-6 py-10 sm:px-[6%] sm:py-11"
      >
        {/* channel bar */}
        <div className="flex flex-wrap items-center gap-3 sm:gap-[14px] mb-6 sm:mb-[26px]">
          <h1
            className="font-playfair text-cream text-[47px] md:text-[59px] leading-[1.05] mb-2 animate-fade-up"
            style={{ animationDelay: "100ms" }}
          >
            OUR{" "}
            <span
              className="font-script italic text-tgc-pink-soft"
              style={{ fontSize: "2.15em" }}
            >
              faves
            </span>
          </h1>
        </div>

        {/* episode grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {EPISODES.map((ep, i) => (
            <div
              key={ep.id}
              role="button"
              tabIndex={0}
              onClick={() => playEpisode(ep.spotifyId)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  playEpisode(ep.spotifyId);
                }
              }}
              className="animate-fade-up"
              style={{
                background: "rgba(255,255,255,0.06)",
                borderRadius: "2px",
                overflow: "hidden",
                cursor: "pointer",
                transition:
                  "background 0.2s ease, transform 0.25s ease, box-shadow 0.25s ease",
                animationDelay: `${i * 110}ms`,
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.background = "rgba(255,255,255,0.12)";
                el.style.transform = "translateY(-4px)";
                el.style.boxShadow = "0 14px 28px -10px rgba(0,0,0,0.45)";
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.background = "rgba(255,255,255,0.06)";
                el.style.transform = "translateY(0)";
                el.style.boxShadow = "none";
              }}
            >
              <img
                src={ep.thumbnail}
                alt={ep.title}
                style={{ width: "100%", display: "block" }}
              />
              <div style={{ padding: "14px" }}>
                <div
                  className="font-montserrat text-white whitespace-normal sm:whitespace-pre-line"
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    lineHeight: 1.4,
                    marginBottom: "14px",
                  }}
                >
                  {ep.title}
                </div>
                <div
                  className="font-montserrat"
                  style={{
                    fontSize: "15px",
                    color: "rgba(255,255,255,0.82)",
                    lineHeight: 1.5,
                  }}
                >
                  {ep.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
